import { IUpdateMetaStatusControleCentroCustoUseCase } from "../../../presentation/useCases/update/update_meta_status_controle_centro_custo_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * UpdateMetaStatusControleCentroCustoUseCase
 */

export class UpdateMetaStatusControleCentroCustoUseCase implements IUpdateMetaStatusControleCentroCustoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async updateMetaStatusControleCentroCusto(
    idControleCentroCusto: number,
    meta: number | null,
    status: number | null,
  ): Promise<void> {
    await this.repository.updateMetaStatusControleCentroCusto(
      idControleCentroCusto,
      meta ?? 0,
      status ?? 0,
    );
  }
}
